<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiDownload } from "@mdi/js";
export default {
  name: "MdiDownload",
  data() {
    return {
      svgPath: mdiDownload,
    };
  },
};
</script>
